


























































































// Importing components
import BaseInputField from '@/ui/BaseInputField.vue';
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import TheDeliveryFields from '@/components/restaurants/TheDeliveryFields.vue';
import TheWorkingHoursFields from '@/components/restaurants/TheWorkingHoursFields.vue';
// Importing variables
import {TagsRestaurant} from '@/ts/variables';

export default {
    name: 'TheFormRestaurants2',
    components: {
        BaseInputField,
        BaseButton,
        BaseLoadingAnimation,
        TheDeliveryFields,
        TheWorkingHoursFields,
    },
    props: {
        restaurant: Object,
        errors: Array,
    },
    data() {
        return {
            temp: Object(),
            tags: Object(),
        };
    },
    methods: {
        addWorkingHours(event) {
            // let days = ['Monday', 'Saturday', 'Sunday'];
            // for (let i = 0; i < this.restaurant.working_hours.length; i++) {
            //     for (let day in days) {
            //         if (this.restaurant.working_hours[i].hasOwnProperty(day)) {
            //             this.restaurant.working_hours[i].start = this.temp.time.start;
            //             this.restaurant.working_hours[i].end = this.temp.time.end;
            //             break;
            //         }
            //     }
            // }
            this.restaurant.working_hours.push(event);
        },
        addDeliveryPrice(event) {
            this.restaurant.delivery_prices.push(event);
        },
        deleteWorkingHour(index) {
            this.restaurant.working_hours.splice(index, 1);
        },
        deleteDeliveryPrice(index) {
            this.restaurant.delivery_prices.splice(index, 1);
        },
    },
    created() {
        this.tags = TagsRestaurant;
    },
};
